import { render, staticRenderFns } from "./TaxonomiesSettings.vue?vue&type=template&id=2b18db18"
import script from "./TaxonomiesSettings.vue?vue&type=script&lang=js"
export * from "./TaxonomiesSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports